import axios from "axios";
import { Constants, CookieService, Utils, MediaOpsService, authansid } from "../../../shared";

export const CreateCreativeService = {

    /**
     * Gets all creatives for a client ID.
     * @function getcreatives
     * @param {string} creativeid - Creative ID.
     * @param {string} campaignSyntheticId - Campaign synthetic ID.
     * @param {string} hasNext - Pagination URL.
     * @param {string} parentId - Parent campaign ID.
     * @param {boolean} isDeleted - Whether to fetch deleted/archived creatives.
     * @returns {[object]}
     * Array of objects, further documentation available at:
     * https://devmediaops-api.annalect.com/dev/docs
    */ 
    getCreatives: (creativeid, campaignSyntheticId, hasNext, parentId, isDeleted = false) => {
        if (creativeid) {
            return axios
                .get(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives', {
                    headers: { ansid: authansid },
                    params: { creativeid: creativeid }})
                .then((response) => { return response }, (error) => { return Promise.reject(error) });
            } else {
            let url = Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives';
            let params = {campaign_id: campaignSyntheticId , page_size: 4000, page_no: 1};
            // let params = { campaign_id: campaignSyntheticId };
            if(parentId){
                params['parent_campaign_id'] = parentId;
            }
            if(isDeleted !== undefined){
                params['isdeleted'] = isDeleted;
            }
            if(hasNext){
                url = hasNext;
                params = {};
            }
            return axios
                .get(url,
                    { headers: { ansid: authansid },
                    params: { ...params }})
                .then((response) => { return response }, (error) => { return Promise.reject(error) });
        }
    },

    /**
        * Creates a new creative.
        * @function createCreative
        * @param {object} payload - Creative object.
        * @returns {object}
        * Object, further documentation available at:
        * https://devmediaops-api.annalect.com/dev/docs
    */
    createCreative: (campaignId, payload, creativeid) => {
        if (creativeid) {
            return axios.post(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives?campaign_id=' + campaignId,
                payload, {
                headers: { ansid: authansid,clientid: Utils.getRouteParam("clientid") },
                params: { creativeid: creativeid }
            })
                .then((response) => { return response },
                    (error) => { return Promise.reject(error) });
        } else {
            return axios.post(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives?campaign_id=' + campaignId,
                payload, { 
                    headers: { ansid: authansid,clientid: Utils.getRouteParam("clientid") }
                })
                .then((response) => { return response },
                    (error) => { return Promise.reject(error) });
        }

    },

    /**
     * Updates an existing creative.
     * @function updateCreative
     * @param {object} payload - Creative object.
     * @returns {object}
     * Object, further documentation available at:
     * https://devmediaops-api.annalect.com/dev/docs
    */ 
    updateCreative: (campaignId, payload, creativeid) => {
        if (creativeid) {
            return axios.put(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives?campaign_id=' + campaignId,
                payload, {
                headers: { ansid: authansid,clientid: Utils.getRouteParam("clientid") },
                params: { creativeid: creativeid }
            })
                .then((response) => { return response },
                    (error) => { return Promise.reject(error) });
        } else {
            return axios.put(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives?campaign_id=' + campaignId,
                payload, { 
                    headers: { ansid: authansid,clientid: Utils.getRouteParam("clientid") } 
                })
                .then((response) => { return response },
                    (error) => { return Promise.reject(error) });
        }
    },

    /**
     * Delete an existing creative.
     * @function deleteCreative
     * @param {object} payload - Creative object.
     * @returns {object}
     * Object, further documentation available at:
     * https://devmediaops-api.annalect.com/dev/docs
    */ 
    deleteCreative: (payload, campaignId) => {
            return axios.put(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives',
                payload, {
                headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid")},
                params: { campaign_id: campaignId }
            })
            .then((response) => { return response },
            (error) => { return Promise.reject(error) });
    },

    /**
     * API details to import creative.
     * @function importCreative
     * @param {object} payload - Payload object.
     * @returns {object}
    */ 
     importCreative: (payload) => {
        return axios
            .post(
                Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + "/creatives/import-creatives",
                payload,
                {
                    headers: {
                        ansid: authansid,
                        clientid: Utils.getRouteParam("clientid"),
                    }
                }
            )
            .then(
                (response) => {
                    return response && response.data;
                }
            );
    },
    
    /**
     * API details to export creative.
     * @function exportCreative
     * @param {boolean} payload - Payload object.
     * @returns {object}
    */ 
    exportCreative: (payload) => {
        return axios
            .post(
                Constants.ClientDataUrl + '/' + Utils.getRouteParam("clientid") + "/creatives/export-creatives",
                payload,
                {
                    headers: {
                        ansid: authansid,
                        clientid: Utils.getRouteParam("clientid"),
                        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                }
            )
            .then(
                (response) => {
                    return response && response.data;
                }
            );
    },

    /**
     * API details to map creative.
     * @function mapCreative
     * @param {object} payload - Payload object.
     * @returns {object}
    */ 
    mapCreative: (payload) => {
        return axios.post(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives/map-creatives',
            payload, {
            headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid")}
        })
        .then((response) => { return response },
        (error) => { return Promise.reject(error) });
    },

    /**
     * API details to unmap creative.
     * @function unMapCreative
     * @param {object} payload - Payload object.
     * @returns {object}
    */ 
    unMapCreative: (payload, options) => {
        return axios.post(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives/unmap-creatives',
            payload, {
            headers: { ansid: authansid, clientid: Utils.getRouteParam("clientid")},
            params: { ...options}
        })
        .then((response) => { return response },
        (error) => { return Promise.reject(error) });
    },

    /**
     * Get creatives by placement ID.
     * @function getPlacementCreative
     * @param {string} placement_id - Placement ID.
     * @returns {object}
    */ 
    getCreativeByPlacementId: (placement_id) => {
        return axios
            .get(Constants.ClientV2DataUrl + '/' + Utils.getRouteParam("clientid") + '/creatives', {
                headers: { ansid: authansid },
                params: { placement_sync_id: placement_id }
            })
            .then((response) => { return response }, (error) => { return Promise.reject(error) });
    },
}
